import { render, staticRenderFns } from "./StartPrint.vue?vue&type=template&id=480e7b3d&scoped=true&"
import script from "./StartPrint.vue?vue&type=script&lang=js&"
export * from "./StartPrint.vue?vue&type=script&lang=js&"
import style0 from "./StartPrint.vue?vue&type=style&index=0&id=480e7b3d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480e7b3d",
  null
  
)

export default component.exports